<template>
  <section class=" ">
    <div style="height: 82vh;">
      <div class="relative">
        <div class="relative">
          <Gadget class="lg:block hidden" />
          <GadgetMobile class="lg:hidden block" />
          <div class="absolute top-10 flex flex-col justify-center items-center w-full z-10">
            <h1 class="lg:text-5xl xl:text-7xl text-5xl text-center">Protect Your <span class="text-army">Gadget</span> <br> with
              <span class="font-bold" style="color: #3E4095">Insurance</span>
            </h1>
          </div>
        </div>
        <div class="absolute w-full pt-2 py-5 lg:py-10 -bottom-0 lg:bottom-0 bg-custom flex lg:flex-row flex-col justify-center lg:gap-4 z-10"
             :class="isDivVisible ? 'block expand-up gap-y-12': 'lg:hidden expand-down gap-y-6' ">
          <div class="lg:hidden flex justify-center ">
            <span @click="isDivVisible = !isDivVisible; mobileshow = !mobileshow">
              <ArrowUp :class="isDivVisible ? '' : 'upsidedown'" />
            </span>
          </div>
          <div class="relative flex justify-center lg:block">
            <BuyLine/>
            <div class="absolute -bottom-5 w-full">
              <div class=" mx-auto flex-col gap-y-1.5 centernewshow flex justify-center items-center w-full">
                <div class="bg-gradient-to-b to-transparent"
                     :class="showDetails.Bronze ? 'bg-custom pt-4 rounded-lg rounded-b-none w-full flex flex-col justify-center items-center' : ''">
                  <h1 class="text-xl font-bold text-center" style="color: #3E4095">Bronze</h1>
<!--                  <p class="text-sm">As low as NGN 250 Per Month</p>-->
                  <ul class="list-disc w-7/12 mx-auto flex flex-col gap-y-1.5 py-3"
                      :class="showDetails.Bronze ? 'block' : 'hidden'">
                    <li class="text-sm">Fire: ₦400,000</li>
                    <li class="text-sm">Burglary: ₦200,000</li>
                    <li class="text-sm">One-off alternative rent benefit: ₦40,000</li>
                    <li class="text-sm">2 Nights Hotel Accommodation: ₦4,000</li>
                    <li class="text-sm">Sum Assured Limit: ₦400,000</li>
                  </ul>
                </div>
                <p class="text-sm text-army cursor-pointer" @click="showDetails.Bronze = false"
                   v-if="showDetails.Bronze">Collapse</p>
<!--                <p class="text-sm text-army cursor-pointer" @click="showDetails.Bronze = true" v-else>Details</p>-->
<!--                <button class="py-2 px-12 text-white font-bold border-2 border-white rounded"-->
<!--                        style="background-color: #00A859" @click="show = true; policyType = 'Individual'">-->
<!--                  Buy-->
<!--                </button>-->
                <p class="text-sm text-army cursor-pointer" >Details</p>
                <button class="py-2 px-12 text-white font-bold border-2 border-white rounded bg-grey">
                  coming soon
                </button>
              </div>
            </div>
          </div>
          <div :class="mobileshow ? 'block' : 'hidden'" class="relative flex justify-center lg:block">
            <BuyLine/>
            <div class="absolute -bottom-5 w-full">
              <div class=" mx-auto flex-col gap-y-1.5 centernewshow flex justify-center items-center w-full">
                <div class="bg-gradient-to-b to-transparent"
                     :class="showDetails.Silver ? 'bg-custom pt-4 rounded-lg rounded-b-none w-full flex flex-col justify-center items-center' : ''">
                  <h1 class="text-xl font-bold text-center" style="color: #3E4095">Silver</h1>
<!--                  <p class="text-sm">As low as NGN 500 Per Month</p>-->
                  <ul class="list-disc w-7/12 mx-auto flex flex-col gap-y-1.5 py-3"
                      :class="showDetails.Silver ? 'block' : 'hidden'">
                    <li class="text-sm">Fire: ₦800,000</li>
                    <li class="text-sm">Burglary: ₦400,000</li>
                    <li class="text-sm">One-off alternative rent benefit: ₦80,000</li>
                    <li class="text-sm">2 Nights Hotel Accommodation: ₦8,000</li>
                    <li class="text-sm">Sum Assured Limit: ₦800,000</li>
                  </ul>
                </div>
                <p class="text-sm text-army cursor-pointer" @click="showDetails.Silver = false"
                   v-if="showDetails.Silver">Collapse</p>
<!--                <p class="text-sm text-army cursor-pointer" @click="showDetails.Silver = true" v-else>Details</p>-->
<!--                <button class="py-2 px-12 text-white font-bold border-2 border-white rounded"-->
<!--                        style="background-color: #00A859" @click="show = true; policyType = 'Corporate'">-->
<!--                  Buy-->
<!--                </button>-->
                <p class="text-sm text-army cursor-pointer" >Details</p>
                <button class="py-2 px-12 text-white font-bold border-2 border-white rounded bg-grey">
                  coming soon
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GadgetModal v-if="show"  :policyType="policyType" v-on:show="show = false"/>
    </div>
  </section>
</template>

<script>
import Gadget from "../../components/ProductImage/lottiegadget.vue"
import GadgetMobile from "../../components/ProductImage/gadgetmobileimage.vue"
import BuyLine from "@/components/ProductImage/BuyLine.vue";
import GadgetModal from "./Modals/Gadget.vue";
import ArrowUp from "@/assets/icons/arrowup.vue";
export default {
  components: {ArrowUp, BuyLine, Gadget, GadgetModal, GadgetMobile },
  data() {
    return {
      isDivVisible: false,
      showDetails: {
        Bronze: false,
        Silver: false,
        Gold: false
      },
      show: false,
      showSecurity: false,
      mobileshow: false,
      policyType: ''
    }
  },
  mounted() {
    console.log('Component mounted!');
    window.addEventListener('scroll', this.handleScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const screenWidth = window.innerWidth;
      if (screenWidth < 1024) {
        this.isDivVisible = false;
      }else {
        if (!this.isScrolling) {
          console.log('Scroll initiated!');
          this.isScrolling = true;

          this.isDivVisible = true;
        }
        const scrollY =
            window.scrollY || document.body.scrollTop || document.documentElement.scrollTop;
        console.log('Scroll Position:', scrollY);
        this.isDivVisible = scrollY > 2;
      }
    },
  }
}
</script>

<style scoped>

.upsidedown {
  transform: rotate(180deg);
}

.expand-up {
  animation: expandUp 0.5s ease forwards;
  padding-bottom: 4rem;
}

@keyframes expandUp {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.expand-down {
  animation: expandDown 0.5s ease forwards;
  padding-bottom: 4rem;
}

@keyframes expandDown {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
</style>